import SwiperSlider from '@/components/swiper-slider';

export const initProjectsSlider = (wrapper: HTMLElement): void => {
    const sliderElement = wrapper.querySelector<HTMLElement>('.j-projects__slider');
    const nextEl = wrapper.querySelector('.j-projects__slider-next');
    const prevEl = wrapper.querySelector('.j-projects__slider-prev');

    if (!sliderElement) {
        return;
    }

    const settings = {
        wrapperClass : 'j-projects__slider-wrapper',
        slideClass   : 'j-projects__slider-slide',
        slidesPerView: 'auto',
        loop         : false,
        navigation   : {
            nextEl,
            prevEl
        }
    };

    const slider = new SwiperSlider({
        item: sliderElement,
        settings
    });

    slider.init();
};

export default initProjectsSlider;
